module.exports = ".mat-elevation-z8{padding:30px;background-color:#ffffff}\n"